export const CURRENT_USER = 'CURRENT_USER'
export const USER_LOADING = 'USER_LOADING'
export const SIGN_UP = 'SIGN_UP'
export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const AUTH_ERROR = 'AUTH_ERROR'
